// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".post-body[data-v-6d59699e],.post-header[data-v-6d59699e]{background:none}", ""]);
// Exports
module.exports = exports;
